import { gql } from "generated-graphql";

gql(`
fragment CohortMemberFragment on CohortMember {
  id
  status
  cohortId
  createdAt
  createdBy
  updatedAt
  updatedBy
  tierIIReportId
  chemicalCount
  facility {
    id
    name
    city
    state
    county
    companyName
    customerFacilityId
    tenantId
    naicsCode
    streetAddress1
    streetAddress2
    zip
    tenant {
      id
      name
    }
  }
  cohort {
    id
    type
    status
    currentWorkflow {
      status
    }
  }
}
`);

gql(`
fragment KsFacilityBreakdownFields on KsFacilityBreakdown {
  facilityId
  facilityName
  nonEhsChemicalCount
  nonEhsTotalLbs
  nonEhsFee
  ehsChemicalCount
  ehsTotalLbs
  ehsFee
  totalFee
}
`);

export const COHORT_MEMBERS_TABLE_QUERY = gql(`
  query CohortMembersTable($cohortId: ID!, $search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    cohortMembers(cohortId: $cohortId, search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...CohortMemberFragment
      }
      count
    }
  }
`);

gql(`
  fragment CohortFragment on Cohort {
    id
    tenantId
    tenant {
      id
      name
    }
    members {
      id
    }
    type
    status
    reportingYear
    createdAt
    createdBy
    updatedAt
    updatedBy
    currentWorkflow {
      status
    }
  }
  `);

export const UPDATE_COHORT_ACTIVITY_MUTATION = gql(`
  mutation UpdateCohortActivity($id: ID!, $input: ActivityInput!) {
    updateCohortActivity(id: $id, input: $input) {
      id
      type
      status
      executionPlan
      assigneeId
      description
      createdAt
      updatedAt
      assignee {
        id
        email
        person {
          first
          last
        }
      }
      workflow {
        id
        status
      }
    }
  }
`);

export const CONDUCT_COHORT_MUTATION = gql(`
  mutation ConductCohort($cohortId: ID!) {
    conductCohort(cohortId: $cohortId)
  }
`);
